import { Component } from '@theme/component';

class HairOticVideoHero extends Component {
  #controller;
  #screen;
  #video;
  #current;
  #userPaused = false;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#screen = matchMedia('(max-width: 749px)');
    const { signal } = this.#controller;
    this.#screen.addEventListener('change', this.#select, { signal });
    document.addEventListener('visibilitychange', this.#startPlayback, { signal });
    window.addEventListener('pageshow', this.#startPlayback, { signal });
    this.#select();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#video?.pause();
    this.#video = undefined;
    this.#current = undefined;
  }

  #select = () => {
    const mobile = this.#screen.matches && this.querySelector('template[data-mobile-video]');
    const template = mobile || this.querySelector('template[data-desktop-video]') || this.querySelector('template[data-mobile-video]');
    if (!template || this.#current === template) return;
    this.#video?.pause();
    const video = template.content.querySelector('video')?.cloneNode(true);
    if (!(video instanceof HTMLVideoElement)) return;
    this.#current = template;
    this.#video = video;
    this.#userPaused = false;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = this.dataset.autoplay === 'true';
    video.preload = video.autoplay ? 'auto' : 'metadata';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.tabIndex = -1;
    video.addEventListener('loadedmetadata', this.#startPlayback, { signal:this.#controller.signal });
    video.addEventListener('canplay', this.#startPlayback, { signal:this.#controller.signal });
    video.addEventListener('play', this.#sync, { signal:this.#controller.signal });
    video.addEventListener('pause', this.#sync, { signal:this.#controller.signal });
    video.addEventListener('error', this.#sync, { signal:this.#controller.signal });
    this.querySelector('[data-video-target]')?.replaceChildren(video);
    const button = this.querySelector('button');
    if (button) button.hidden = false;
    this.#sync();
    this.#startPlayback();
  };

  #startPlayback = () => {
    const video = this.#video;
    if (!video || !video.paused || this.#userPaused || document.hidden) return;
    if (this.dataset.autoplay !== 'true') return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.play().catch(this.#sync);
  };

  #sync = () => {
    const button = this.querySelector('button');
    if (!button || !this.#video) return;
    const paused = this.#video.paused;
    button.setAttribute('aria-label', paused ? this.dataset.play : this.dataset.pause);
    button.textContent = paused ? '▶' : 'Ⅱ';
  };

  togglePlayback() {
    if (!this.#video) return;
    this.#userPaused = !this.#video.paused;
    if (this.#userPaused) this.#video.pause();
    else this.#video.play().catch(this.#sync);
  }
}

if (!customElements.get('hm-video-hero')) customElements.define('hm-video-hero', HairOticVideoHero);
